<template>
  <div class="vff-animate q-form f-fade-in-up">
    <div class="q-inner">
      <div v-if="translatedCategories.length > 0">
        <div class="fh2">
          <div class="f-answer f-full-width">
            <CustomRadioList
              :options="radioListOptions"
              layout="vertical"
              label-align="between"
              @option-selected="handleCategorySelected"
            />
          </div>
        </div>
      </div>

      <div
        v-else
        class="unavailable-selection-notification unavailable-selection-notification--adviser"
      >
        <div class="unavailable-selection-notification__icon">
          <AppIcon icon="warning" />
        </div>
        <div class="unavailable-selection-notification__text text-lg-nowrap">
          <p class="my-3 fs-5" v-html="$t('kb.no_categories')"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { router } from '@inertiajs/vue3'
import { KbServicesData, KbLocalization, KbCountLocalization } from '~types/concierge'
import CustomRadioList, {
  RadioListOption
} from '~conciergeUiCommons/components/CustomRadioList.vue'

export default defineComponent({
  name: 'KbCategories',
  components: { CustomRadioList },
  props: {
    categories: {
      type: Array as PropType<KbServicesData[]>,
      required: true
    },
    lang: {
      type: String as PropType<keyof KbLocalization>,
      required: true
    }
  },
  computed: {
    translatedCategories(): KbServicesData[] {
      return this.categories
        .filter(category => {
          return (
            category.name[this.lang as keyof KbLocalization] !== '' &&
            category.name[this.lang as keyof KbLocalization] !== null &&
            category.articlesCount[this.lang as keyof KbCountLocalization] > 0
          )
        })
        .map(category => {
          return {
            ...category,
            name: category.name[this.lang as keyof KbLocalization],
            articlesCount: category.articlesCount[this.lang as keyof KbCountLocalization]
          }
        })
    },
    radioListOptions(): RadioListOption[] {
      return this.translatedCategories.map(category => ({
        label: category.name,
        secondary: category.articlesCount.toString(),
        highlightSecondary: true,
        value: category
      }))
    }
  },
  methods: {
    goToAnswer(service: KbServicesData): void {
      if (
        Object.hasOwn(service.endpoints, 'questions') &&
        service.endpoints.questions[this.lang as keyof KbLocalization]
      ) {
        return router.visit(
          service.endpoints.questions[this.lang as keyof KbLocalization] as string
        )
      }
    },
    handleCategorySelected(_value: any, option: RadioListOption) {
      const service = this.translatedCategories.find(cat => cat.name === option.label)
      if (service) {
        this.goToAnswer(service)
      }
    }
  }
})
</script>
